import { React, useState, useEffect } from 'react'
import './GoldenOfferComponent.css'
import { MdLocalOffer } from 'react-icons/md'
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Row, Col } from 'react-bootstrap';
import TimerComponent from '../TimerComponent/TimerComponent';
import { PiBagSimple } from 'react-icons/pi'
import { BiUser } from 'react-icons/bi'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';
import ImageNotFound from '../../Assets/images/ImageNotFound.jpg'
import { Link } from 'react-router-dom';

export default function GoldenOfferComponent({ item }) {
  let startDate = new Date(item.startTime);
  let currentDate = new Date();

  let timeDiff = currentDate.getTime() - startDate.getTime();
  let daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

  return (

    <div className='golden-Offer-item'>
      <div className='golden-offer-header'>
        <div className='golden-offer-title'>
          <div className='golden-offer-title-icon'>
            <MdLocalOffer />
          </div>
          تخفیفات شگفت انگیز
        </div>

      </div>
      <Row className='golden-offer-content'>
        <Col lg={4} className='golden-offer-right'>
          <div className='golden-offer-image'>
            <Link to={"/course/" + item.title}>
              <div className='golden-offer-image-wrapper'>
                {
                  item?.course.imagePath != null ? (
                    <img src={axiosConfig.defaults.baseURL + "Images/CourseImage/" + item?.course.id + "/" + item?.course.imagePath} alt={item.title} />
                  ) : (
                    <img src={ImageNotFound} alt={item.title} />
                  )
                }
              </div>
            </Link>

          </div>
        </Col>
        <Col className='golden-offer-left'>
          <div className='title-courses'>
            <Link to={"/course/" + item.title}>

              {item?.course.title}
            </Link>
          </div>
          <div className='offer-progress-bar'>
            <ProgressBar now={item?.course.percentComplete} />
            <h3>{item?.course.percentComplete} درصد دوره تکمیل شده</h3>
          </div>
          <ul>
            <li>
              <PiBagSimple />
              سطح دوره : {item?.course.courseLevel === 0 ? 'مبتدی' : item?.course.courseLevel === 1 ? 'متوسط' : item?.course.courseLevel === 2 ? 'پیشرفته' : ''}
            </li>
            <li>
              <BiUser />
              مدرس دوره : {item.course.instructorName}
            </li>
          </ul>
          <Row className='course-price-timer'>
            <Col>
              <div className='course-price'>
                <div className='course-offs'>
                  {item?.percent}%
                </div>
                <div className='course-prev-price'>
                  {item?.course.price.toLocaleString("fa-IR")}
                </div>
                <div className='course-current-price'>
                  {(item?.course.price - ((item?.course.price * item?.percent) / 100)).toLocaleString("fa-IR")} تومان
                </div>
              </div>
            </Col>
            <Col>
              <TimerComponent time={(parseInt(item.duration) - daysDiff)} />
            </Col>


          </Row>
        </Col>
      </Row>
    </div>
  )
}
